export default "__VITE_ASSET__B9n3y5SH__"